/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../../constants"
import { sendToLogServer } from "../../../../core/service/BusinessLogicService"
import AdyenCheckout from "@adyen/adyen-web"
import axios from "axios"

/* constants */
const ADYEN_CREATE_SESSION_URL = "middle-bank-service/api/v2/payment/adyen/create-session"

export function processAdyenPayment(
  tunnelData,
  onSetStep,
  setHasAlreadyFailedCb,
  setPaymentButtonLock,
  setShowAdyenModal
) {
  const token = tunnelData.access_token
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "*/*",
    "Content-Type": "application/json"
  }

  function generateAdyenConfigurationRetailFnacPT(res, tunnelData, onSetStep) {
    return {
      environment: tunnelData.adyen.environment,
      clientKey: tunnelData.adyen.clientKey,
      session: {
        id: res.data.id,
        sessionData: res.data.sessionData
      },
      locale: tunnelData.data.order.orderLanguageTag.replace("-", "_"),
      redirectFromTop: true,
      onPaymentCompleted: (result, component) => {
        console.info(result, component)
        onSetStep({
          ...tunnelData,
          adyenError: result.resultCode !== "Authorised"
        })
      },
      onError: (error, component) => {
        console.error(error.name, error.message, error.stack, component)
        onSetStep({
          ...tunnelData,
          adyenError: true
        })
      },
      paymentMethodsConfiguration: {
        mbway: {
          showImage: true
        },
        multibanco: {
          showImage: true
        },
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          name: "Cartão de crédito",
          amount: {
            value: res.data.amount.value,
            currency: res.data.amount.currency
          }
        }
      }
    }
  }

  // create adyen session
  axios
    .get(tunnelData.apiUrl + ADYEN_CREATE_SESSION_URL, {
      headers: headers,
      params: { opl: tunnelData.opl, tenant: tunnelData.tenant }
    })
    .then((res) => {
      let configuration = {
        environment: tunnelData.adyen.environment, // Change to 'live' for the live environment.
        clientKey: tunnelData.adyen.clientKey, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        session: {
          id: res.data.id, // Unique identifier for the payment session.
          sessionData: res.data.sessionData // The payment session data.
        },
        locale: tunnelData.data.order.orderLanguageTag.replace("-", "_"),
        redirectFromTop: true,
        paymentMethodsConfiguration: {
          ideal: {
            showImage: true
          }
        },
        onPaymentCompleted: (result, component) => {
          sendToLogServer("INFO", "Adyen result for " + tunnelData.opl + " : " + JSON.stringify(result))
          onSetStep({
            ...tunnelData,
            adyenError: result.resultCode !== "Authorised"
          })
        },
        onError: (error, component) => {
          sendToLogServer("ERROR", "Adyen result for " + tunnelData.opl + " : " + JSON.stringify(error))
          let adyenError = true
          if ((tunnelData.tenant === TENANTS.MEDIAMARKT_NL || tunnelData.tenant === TENANTS.MEDIAMARKT_BE || tunnelData.tenant === TENANTS.SAMSUNG_NL) && JSON.stringify(error).includes("NETWORK_ERROR"))
            adyenError = false //Si on a le network error et que le tenant est mediamarkt ou samsung nl, alors on ignore cette erreur car on l'étape de vérification
          onSetStep({
            ...tunnelData,
            adyenError
          })
        }
      }
      if (tunnelData.tenant === "retail_fnac_pt") {
        configuration = generateAdyenConfigurationRetailFnacPT(res, tunnelData, onSetStep)
      }
      // Create an instance of AdyenCheckout using the configuration object.
      console.log(configuration)
      AdyenCheckout(configuration).then((res) => {
        setShowAdyenModal(true)
        res.create("dropin").mount("div#dropin-container")
        setPaymentButtonLock(false)
      })
    })
    .catch((e) => {
      console.log(e)
      setHasAlreadyFailedCb(true)
      setPaymentButtonLock(false)
    })
}
